import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { NewsletterType } from '@pai/commons'

import { InputFieldComponent, InputFieldTheme } from '../input-field/input-field.component'
import { TextareaAutosizeDirective } from '../textarea-autosize.directive'
import { TranslatePipe } from '../translate.pipe'
import { NewsletterSubscriptionForm } from './newsletter-subscription.form'

@Component({
  selector: 'pai-newsletter-subscription-form',
  imports: [InputFieldComponent, ReactiveFormsModule, TranslatePipe, TextareaAutosizeDirective],
  templateUrl: './newsletter-subscription-form.component.html',
  styleUrl: './newsletter-subscription-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterSubscriptionFormComponent {
  static instanceCounter = 0
  readonly #instanceNo = ++NewsletterSubscriptionFormComponent.instanceCounter

  readonly form = input.required<NewsletterSubscriptionForm>()
  readonly appearance = input.required<InputFieldTheme>()

  protected readonly radioGroupName: string = `newsletter-subscription-${this.#instanceNo}`
  protected readonly radioGroupLabelId: string = `newsletter-subscription-${this.#instanceNo}-label`

  protected readonly NewsletterType = NewsletterType
}
